import { useRef } from "react";
import { motion, useInView } from "motion/react";
import * as Icons from "lucide-react";
import { siteData } from "../../data/mock";

const spring = { type: "spring", damping: 80, stiffness: 400, mass: 1 };

const FeatureCard = ({ feature, index, inView }) => {
  const IconComponent = Icons[feature.icon] || Icons.Star;

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ ...spring, delay: 0.1 + index * 0.08 }}
      className="group relative bg-white rounded-2xl p-6 md:p-8 border border-[#E6E4EB] hover:border-[#008055]/30 hover:shadow-lg hover:shadow-[#008055]/5 cursor-default"
      style={{ transition: "border-color 0.3s ease, box-shadow 0.3s ease" }}
    >
      <div className="w-12 h-12 rounded-xl bg-[#008055]/8 flex items-center justify-center mb-5 group-hover:bg-[#008055]/15" style={{ transition: "background-color 0.3s ease" }}>
        <IconComponent size={22} className="text-[#008055]" />
      </div>
      <h3 className="text-[#0A0A0A] text-lg font-medium mb-2 tracking-tight">
        {feature.title}
      </h3>
      <p className="text-[#3C3B3D] text-[15px] leading-relaxed">
        {feature.description}
      </p>
    </motion.div>
  );
};

export const FeaturesSection = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section ref={ref} id="features" className="py-20 md:py-28 bg-white">
      <div className="max-w-[1200px] mx-auto px-6 md:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ ...spring }}
          className="max-w-[600px] mb-14"
        >
          <span className="inline-block text-[#008055] text-sm font-medium bg-[#008055]/8 rounded-full px-4 py-1.5 mb-4">
            Why P2Points
          </span>
          <h2
            className="text-[#0A0A0A] leading-tight tracking-tight mb-4"
            style={{ fontSize: "clamp(28px, 4vw, 40px)", fontWeight: 500 }}
          >
            What Makes It{" "}
            <span className="text-[#008055]">Powerful</span>
          </h2>
          <p className="text-[#3C3B3D] text-lg leading-relaxed">
            Everything you need to run a modern loyalty program — nothing you don't.
          </p>
        </motion.div>

        {/* Feature Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {siteData.features.map((feature, i) => (
            <FeatureCard key={i} feature={feature} index={i} inView={inView} />
          ))}
        </div>
      </div>
    </section>
  );
};
